import React from 'react';
import {Table} from 'react-bootstrap'
import ResultListRow from './ResultListRow'

export default (props) => {
    return (
        <Table bordered hover size="sm">
        <thead className="thead-dark"> 
            <tr>
                <th>Pl</th>
                <th>Navn</th>
                <th className="d-none d-sm-table-cell">Etternavn</th>
                <th className="d-none d-sm-table-cell">Klubb</th>
                <th>Tid</th>
                <th className="d-none d-sm-table-cell"></th>
            </tr>
        </thead>
        <tbody>
        {props.competitors ? props.competitors.sort( (a, b) => a.finalSortNo - b.finalSortNo ).map( competitor => 
            <ResultListRow selectCompetitor={props.selectCompetitor} event={props.event} key={competitor.id} competitor={competitor} />
            )
        : null}
        </tbody>
        </Table>

    );
};
